import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { login as authentication } from './sessions/loginReducer';
import { member } from './members/memberReducer';
import { memberships } from './members/membershipsReducer';
import { membership } from './members/membershipReducer';
import { accounts } from './members/accountsReducer';
import { account } from './members/accountReducer';
import { trainers } from './users/trainerReducer';
import { businessHours } from './users/businessHoursReducer';
import { appointment } from './appointments/appointmentReducer';
import { appointments } from './appointments/appointmentsReducer';
import { schedule } from './appointments/scheduleReducer';
import { activities } from './configs/activitiesReducer';
import { categories } from './pos/categoriesReducer';
import { products } from './pos/productsReducer';
import { posOrders, posOrder } from './pos/ordersReducer';
import { posConfig } from './pos/configReducer';
import { alert } from './alertsReducer';
import { spinner } from './spinnerReducer';

const rootReducer = combineReducers({
    form: formReducer,
    authentication,
		alert,
		member,
		memberships,
		membership,
		accounts,
		account,
		trainers,
    businessHours,
    appointment,
    appointments,
		schedule,
		activities,
		categories,
		products,
    posOrders,
    posOrder,
		posConfig,
		spinner
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js